(function () {
    var root = document.getElementById('md-acc-edit-app');
    if (!root || typeof mdMealPrep === 'undefined') {
        return;
    }
    var M = window.MDMeals;
    if (!M || !M.api) {
        return;
    }

    var form = document.getElementById('md-acc-edit-form');
    var pwForm = document.getElementById('md-acc-password-form');
    var passwordWrap = document.getElementById('md-acc-password-wrap');
    var passwordHeading = document.getElementById('md-acc-password-heading');
    var passwordLede = document.getElementById('md-acc-password-lede');
    var passwordStatus = document.getElementById('md-acc-password-status');
    var curPwLi = document.getElementById('md-acc-cur-pw-li');
    var passwordSave = document.getElementById('md-acc-password-save');
    var loading = document.getElementById('md-acc-edit-loading');
    var errEl = document.getElementById('md-acc-edit-error');
    var statusEl = document.getElementById('md-acc-edit-status');
    var saveBtn = document.getElementById('md-acc-edit-save');
    var phoneEl = document.getElementById('md-acc-edit-phone');
    var verifyWrap = root.querySelector('.md-acc-edit-verify-wrap');
    var verifyLink = document.getElementById('md-acc-edit-verify-link');
    var otpBase = root.getAttribute('data-otp-url') || '';
    var fromWelcome = (root.getAttribute('data-from') || '') === 'welcome';
    var accountUrl = root.getAttribute('data-account-url') || '/account/';

    function esc(s) {
        return M.esc(String(s == null ? '' : s));
    }
    function showErr(m) {
        if (!errEl) return;
        if (m) {
            errEl.textContent = m;
            errEl.hidden = false;
        } else {
            errEl.textContent = '';
            errEl.hidden = true;
        }
    }
    function showStatus(m) {
        if (statusEl) statusEl.textContent = m || '';
    }
    function showPasswordStatus(m) {
        if (passwordStatus) passwordStatus.textContent = m || '';
    }
    function fmtPhone(d) {
        var s = String(d || '').replace(/\D/g, '');
        if (s.length === 10) return '(' + s.slice(0, 3) + ') ' + s.slice(3, 6) + '-' + s.slice(6);
        return s;
    }
    function welcomeRedirect(savedKey) {
        try {
            var u = new URL(accountUrl, window.location.origin);
            u.pathname = u.pathname.replace(/\/?$/, '/') + 'welcome/';
            u.searchParams.set('saved', savedKey);
            window.location.href = u.toString();
        } catch (e) {
            window.location.href = accountUrl + 'welcome/?saved=' + encodeURIComponent(savedKey);
        }
    }

    function applyPasswordSection(d) {
        if (!d || !passwordWrap) {
            return;
        }
        passwordWrap.hidden = false;
        if (passwordHeading) {
            passwordHeading.textContent = d.has_password ? 'Change password' : 'Set a password';
        }
        if (passwordLede) {
            passwordLede.textContent = d.has_password
                ? 'Update the password you use to sign in with your email or phone.'
                : 'Add a password if you want to sign in with email or phone, not just a one-time code.';
        }
        if (curPwLi) {
            curPwLi.hidden = !d.has_password;
        }
        var cur = document.getElementById('md-acc-cur-pw');
        if (cur) {
            cur.value = '';
            if (!d.has_password) {
                cur.removeAttribute('required');
            } else {
                cur.setAttribute('required', 'required');
            }
        }
    }

    function applyProfile(d) {
        if (!d || !form) return;
        var fn = document.getElementById('md-acc-edit-fn');
        var ln = document.getElementById('md-acc-edit-ln');
        var em = document.getElementById('md-acc-edit-email');
        if (fn) fn.value = d.first_name || '';
        if (ln) ln.value = d.last_name || '';
        if (em) em.value = d.email || '';
        if (phoneEl) phoneEl.value = fmtPhone(d.phone);
        applyPasswordSection(d);
        if (verifyWrap && verifyLink) {
            if (!d.phone_verified && d.phone) {
                verifyWrap.hidden = false;
                var u = otpBase;
                try {
                    var x = new URL(u, window.location.origin);
                    x.searchParams.set('phone', d.phone);
                    if (fromWelcome) x.searchParams.set('from', 'welcome');
                    u = x.pathname + x.search;
                } catch (e) {
                    u = u + (u.indexOf('?') >= 0 ? '&' : '?') + 'phone=' + encodeURIComponent(d.phone);
                }
                verifyLink.setAttribute('href', u);
            } else {
                verifyWrap.hidden = true;
            }
        }
    }

    function load() {
        showErr('');
        M.api('profile', { method: 'GET' })
            .then(function (d) {
                if (loading) {
                    loading.hidden = true;
                    loading.setAttribute('aria-busy', 'false');
                }
                form.hidden = false;
                applyProfile(d);
            })
            .catch(function (e) {
                if (loading) {
                    loading.innerHTML = '<p class="md-meals-error">' + esc(e.message || e) + '</p>';
                }
            });
    }

    if (pwForm) {
        pwForm.addEventListener('submit', function (e) {
            e.preventDefault();
            showErr('');
            showPasswordStatus('');
            if (passwordSave) {
                passwordSave.disabled = true;
            }
            var fd = new FormData(pwForm);
            var newP = String(fd.get('new_password') || '');
            var conf = String(fd.get('confirm_password') || '');
            if (newP !== conf) {
                showErr('New password and confirmation do not match.');
                if (passwordSave) {
                    passwordSave.disabled = false;
                }
                return;
            }
            M.api('auth/password', {
                method: 'POST',
                body: {
                    new_password: newP,
                    confirm_password: conf,
                    current_password: String(fd.get('current_password') || ''),
                },
            })
                .then(function () {
                    showPasswordStatus('Password saved.');
                    pwForm.reset();
                    if (curPwLi) {
                        curPwLi.hidden = false;
                    }
                    var cur = document.getElementById('md-acc-cur-pw');
                    if (cur) {
                        cur.setAttribute('required', 'required');
                    }
                    if (passwordHeading) {
                        passwordHeading.textContent = 'Change password';
                    }
                    if (passwordLede) {
                        passwordLede.textContent =
                            'Update the password you use to sign in with your email or phone.';
                    }
                    return M.api('profile', { method: 'GET' });
                })
                .then(function (d) {
                    if (d) {
                        applyPasswordSection(d);
                    }
                    if (passwordSave) {
                        passwordSave.disabled = false;
                    }
                    setTimeout(function () {
                        showPasswordStatus('');
                    }, 4000);
                })
                .catch(function (err) {
                    showErr(err.message || String(err));
                    if (passwordSave) {
                        passwordSave.disabled = false;
                    }
                });
        });
    }

    if (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            showErr('');
            showStatus('');
            if (saveBtn) {
                saveBtn.disabled = true;
            }
            var fd = new FormData(form);
            var body = {
                first_name: fd.get('first_name'),
                last_name: fd.get('last_name'),
                email: fd.get('email'),
            };
            M.api('profile', { method: 'POST', body: body })
                .then(function (d) {
                    applyProfile(d);
                    showStatus('Saved.');
                    if (saveBtn) {
                        saveBtn.disabled = false;
                    }
                    setTimeout(function () {
                        showStatus('');
                    }, 3000);
                })
                .catch(function (err) {
                    showErr(err.message || String(err));
                    if (saveBtn) {
                        saveBtn.disabled = false;
                    }
                });
        });
    }

    load();
})();
